import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Spinner, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-vwsa-spinner',
    template: ''
})
export class VWSASpinnerComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://lsg-auth.prodworksngwsa.de/components-core/?path=/docs/components-spinner--spinner
    @Input() variant = 'x-large';

    ElementToShow = () => (
        <ThemeProvider>
            <Spinner variant={this.variant as any} />
        </ThemeProvider>
    );

    constructor(private hostRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('ngOnChanges: ' + this.hostRef.nativeElement);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('ngOnDestroy');
        //removing this for now because it causes delays when navigating.
        //find a way to call it async so it doesn't delay navigation
        //or change the navigation so pages are preloaded and also not destructed.
        //ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }
}
